import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { RenderedService } from '../../rendered.service';
import { LtiService } from '@services/lti.service';
import { ItemsService } from '@scaffold/services/items.service';
import { HttpUtilService } from '@services/http-util.service';
import { environment } from '@env/environment';

@Component({
    selector: 'app-data-import',
    templateUrl: './data-import.component.html',
    styleUrls: ['./data-import.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
/**
 * @fileoverview allows importing data from various formats
 */
export class DataImportComponent
  extends BaseScaffoldComponent
  implements OnInit
{
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private LTIService: LtiService,
    private itemsService: ItemsService,
    private http: HttpUtilService
  ) {
    super(cdr, renderedService);
  }
  input;
  url;
  output;
  ngOnInit() {}

  dataInput() {
    if (this.item.format === 'lti') {
      this.LTIService.getConfiguration(this.input).subscribe(result => {
        this.output = result;
        console.log(this.output);
        Object.keys(result).forEach(key =>
          this.sendUpdate(key, result[key], this.info)
        );
      });
    }
  }

  /**
   *
   * @param key
   * @param value
   * @param info
   * @param error
   */
  sendUpdate(key, value, info, error?) {
    console.log('updating ' + key, value);
    console.log(info);
    this.itemsService.updateValue(key, value, info, error);
  }

  getSettings() {
    if (this.url && this.url.length > 0 && this.url.match(/^https*:/i)) {
      this.http
        .request(
          'GET',
          environment.apiRoot +
            '/launch/configuration?url=' +
            encodeURIComponent(this.url),
          null,
          null,
          true
        )
        .subscribe(r => {
          console.log(r);
          if (this.item.format === 'lti') {
            this.LTIService.getConfiguration(r.content).subscribe(result => {
              this.output = result;
              console.log(this.output);
              Object.keys(result).forEach(key =>
                this.sendUpdate(key, result[key], this.info)
              );
              this.update();
            });
          }
        });
    }
  }
}
